module.exports = __webpack_public_path__ + "media/images/red-up-1f3311ff4c5c8bf25c4594d0602f2617.svg";